<template>
  <FormLabel :checkboxmode="true" :descr="descr">
    <HiddenField type='checkbox' :name="name" :value="val"/>
    <div role="checkbox" :aria-checked="val" :tabindex="$store.state.loading?-1:0" class="aoformcheckbox" :class="{'aoformcheckbox_light' : light}" @click="val = !val" @keydown.enter.space="val = !val">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 15">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.744 1.67008L7.22995 14.4401L0.303955 7.71808L1.69696 6.28308L7.13396 11.5601L17.258 0.330078L18.744 1.67008Z"></path>
      </svg>
    </div>
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import HiddenField from '@/components/HiddenField.vue'

export default {
  components: { FormLabel, HiddenField },
  mixins: [FormField],
  props: {
    name: {type: String, required: true},
    descr: {type: String, required: true},
    light: {type: Boolean, default: false},
    required: {type: Boolean, default: true},
    value: {type: Boolean, default: false}
  },
  data: ()=>({
    collector: {}
  }),
  mounted(){
    if (this.$parent.fieldsStatus)
      this.collector = this.$parent.fieldsStatus
    else if (this.$parent.$parent.fieldsStatus)
      this.collector = this.$parent.$parent.fieldsStatus
    if (this.collector)
      this.checkValue(this.value)
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  watch:{
    value(val){
      this.checkValue(val)
    }
  },
  methods: {
    checkValue(val){
      if (val || !this.required)
        this.collector[this.name] = true
      else
        this.collector[this.name] = false      
    }
  }
}
</script>

<style lang="sass">
.aoformcheckbox
  position: relative
  z-index: 1
  outline: none
  &:focus-visible
    outline: auto
  &::before
    content: ''
    position: absolute
    top: -15px
    left: -15px
    right: -15px
    bottom: -15px
  display: flex
  justify-content: center
  align-items: center
  width: 20px
  min-width: 20px
  height: 20px
  border: 2px solid colors.$font
  background: colors.$background
  cursor: pointer
  transition: border-color .2s ease-out
  svg
    transition: opacity .2s ease-out
    fill: colors.$red
    opacity: 0
    width: 18.5px
  &:hover, &:focus
    border-color: colors.$light
  &_light
    border-color: colors.$light
  &[aria-checked=true]
    background: colors.$lightgray
    border-color: rgba(255,255,255,0) !important
    svg
      opacity: 1

</style>